import React from 'react';
import HS from './assets/Kenyatta_Headshot 2021 .jpeg'

export default function About(){
  return (
    <main className="section">
      <div className="container">
        <div className="kicker">About Me</div>
        <h2>My Story</h2>
     
<div className="card span-6">

<div className='about'>
  <div className='about_img'><img src={HS}/></div>
  <div>
  <p>
    I was born and raised in Riviera Beach, Florida. I earned a Bachelor of Arts degree in Sociology from Florida Atlantic University in 2003 and a master’s 
    degree in social work from Barry University in 2011. With nearly two decades of experience in the field of child welfare, including 14 years as a mental health
    clinician and clinical director, I’ve devoted my life to the service of others. Throughout my years working in mental health and social work, I recognized a deep
    need in the community for emotional support, mindset development, and personal transformation. After doing the hard work to transform my own life, I made it my
    mission to help others do the same. In 2020, I founded Kenyatta Speaks, LLC, an organization committed to Mental Fitness, Emotional Intelligence, Mindset Development,
    and Habit Formation. I am a 4D Associates Certified Transformational Coach, a Facilitator of Learning, a Motivational Speaker, and a Mental Health Therapist. At Kenyatta
    Speaks, I support youth, adults, and organizations in discovering their full potential by increasing awareness, shifting limiting beliefs, and developing 
    practical tools for change. I believe every person can change their life by recognizing their worth and walking in their true power. Beyond my professional
    work, I’ve volunteered with numerous organizations throughout the Tri-County area. I am a proud graduate of Leadership Palm Beach County, Class of 2023,
    and I currently serve as a board member for the Girl Scouts of Southeast Florida. I believe that a life of service is a life well lived.
  </p>

  <h3>My Journey</h3>
  <p>
    I understand what it feels like to question your worth. I know what it’s like to show up for everyone else while feeling unseen and unheard. I’ve carried the weight of silent
    burnout—the pressure to hold everything together while quietly unraveling inside. I have experienced the breakdowns, faced the setbacks, and walked through
    seasons of deep self-doubt. But I made the decision to do the inner work. Through intentional healing, reflection, and growth, I rebuilt myself from the inside out.
    That journey has shaped who I am—and it fuels everything I do today.
  </p>

  <h3>My Mission</h3>
  <p>
    Through Kenyatta Speaks, I use both my lived experiences and professional expertise to help individuals and organizations move beyond survival and into a place of strength,
    clarity, and emotional resilience. At the core of every thriving team, organization, or community is one truth I fully believe: leadership starts with you. It begins with
    how you see yourself, how you show up, and how you choose to grow. Whether I’m supporting a professional navigating personal growth, a team struggling with culture
    or youth learning to find their voice, I show up with the same intention—to illuminate possibility and help people lead from the inside out.
  </p>

  <h3>Who I Work With</h3>
  <p>
    I work with frontline agencies, youth facing critical life transitions, and coach leadership teams that are committed to building emotionally healthy, purpose-driven cultures.
    No matter who I’m serving, my mission remains the same:
  </p>
  <p><strong>To transform pain into purpose, and potential into power.</strong></p>

  <p>
    Through intentional guidance, evidence-based frameworks, and a deep commitment to authentic growth, I help individuals and organizations rise with clarity, build emotional resilience, and lead from a place of dignity.
  </p>
  </div>

</div>

</div>


      </div>
    </main>
  )
}
